import { SelectConfig } from '../models';

export const config: SelectConfig = {
  buttonClass: 'q-button-select-default',
  inputClass: 'q-input-select-default',
  listClass: 'q-list-select-default',
};
